import React from 'react';
import Nav from "react-bootstrap/Nav";

export const Jumbotron = (props) => {
  const bgStyle = props.style ?? { backgroundColor: "#e9ecef" };
  // allow callers to override the inner container class so the jumbotron
  // can be full-width when needed (e.g. "container-fluid px-0 py-5")
  const innerContainerClass = props.containerClassName ?? "container py-5";
  return (
    <div id={props.id} className={`py-3 ${props.className}`} style={bgStyle}>
      <div className={innerContainerClass}>
        {props.children}
      </div>
    </div>
  );
}

export const NavLink = (props) => {
  return (
    <Nav.Link
      href={props.href}
      target={props.target}
      rel={props.rel}
    >
      <span className={`nav-item lead ${props.className}`}>
        {props.children}
      </span>
    </Nav.Link>
  );
}
